export const ApiAlgoUser = "vadvisor";
